module.exports = __webpack_public_path__ + "static/media/Delayed truck 1.6dd44b07.svg";